import axios from 'axios'

const state = {
    payment_systems: [],
    banks: [],
    currencies: [],
    countries: [],
    is_free_transfer: false,
}

const getters = {
    StateFee: (state) => !!state.fee,
    GetPaymentSystems: (state) => state.payment_systems,
    GetCurrencies: (state) => state.currencies,
    GetBanks: (state) => state.banks,
    GetCountries: (state) => state.countries,
    IsFreeTransfer: (state) => state.is_free_transfer,
}

const actions = {
    async GetPaymentSystems({ commit }, user) {
        const payment_data = await axios.get("/api/public/payment_data/array").then(res => res.data)
        if (payment_data.result) try { await commit("setPayment", payment_data.data) } catch { }
        return payment_data
    },
    // Получение списка банков
    async GetBanks({ commit }) {
        const banks = await axios.get("/api/public/get_banks/array").then(res => res.data)
        if (banks.result && banks.data) try { await commit("setBanks", banks.data) } catch { }
        return banks
    },
    // Получение списка валют
    async GetCurrencies({ commit }) {
        const currencies = await axios.get("/api/public/get_currencies/array").then(res => res.data)
        if (currencies.result && currencies.data) try { await commit("setCurrencies", currencies.data) } catch { }
        return currencies
    },
    // получение стран
    async GetCountries({ commit }) {
        const countries = await axios.get("/api/public/get_countries/array").then(res => res.data)
        if (countries.result && countries.data) try { await commit("setCountries", countries.data) } catch { }
        return countries
    },
    // Получение настроек
    async ActionGetSettings({ commit }) {
        try {
            const settings = await axios.get("/api/public/get_settings/").then(res => res.data)
            if (settings.result && settings.data) try { await commit("setSettings", settings.data) } catch { }
            return settings
        } catch (error) {
            return { result: false, error: 'Failed to fetch settings' }
        }
    }
}

const mutations = {
    setPayment(state, data) {
        state.payment_systems = data
    },
    setBanks(state, data) {
        state.banks = data;
    },
    setCurrencies(state, data) {
        state.currencies = data;
    },
    setCountries(state, data) {
        state.countries = data;
    },
    setSettings(state, data) {
        state.is_free_transfer = data.is_free_transfer || false;
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}